<div class="docx-viewer-host" [style.height]="height()">
  @if (!isLoaded()) {
    <div class="docx-viewer-overlay">
      <p-progressSpinner strokeWidth="4" [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
      <span class="docx-viewer-overlay__label">Loading document…</span>
    </div>
  }

  @if (error(); as message) {
    <div class="docx-viewer-error">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ message }}</span>
      <p-button label="Retry" icon="pi pi-refresh" size="small" (onClick)="retry()" />
    </div>
  }

  <div #docxContainer class="docx-viewer-container"></div>
</div>
